// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"5827bd8e","165":"191cd8a3","199":"6a39e29c","505":"46c7cb99","648":"76791fec","767":"2cbea49b","787":"26b2e4aa","817":"76f998a6","856":"0cc598a7","869":"3c2862d7"}[chunkId] + ".chunk.js";
};